import { useMemo, useState } from 'preact/hooks';
import './style.css';
import { RATING_DESC } from '../../../../constants';
import { DisappointedFace, GrinningFace, NuetralFace } from '../EmojiRating/constants';

const EmotionRating = ({ id, ratingScore, setRatingScore }) => {
  const [hoverRating, setHoverRating] = useState(0);

  const desc = useMemo(() => {
    if (hoverRating !== 0) {
      return RATING_DESC[hoverRating - 1];
    }
    return RATING_DESC[ratingScore - 1];
  }, [ratingScore, hoverRating]);

  return (
    <div className="rating">
      <div className="emotion-rating">
        <button
          type="button"
          className={`buttonField ${ratingScore === 5 ? 'activeButton' : ''}`}
          onClick={() => setRatingScore(5, id)}
          onMouseEnter={() => setHoverRating(5)}
          onMouseLeave={() => setHoverRating(0)}
        >
          {GrinningFace()}
          <span>
            Happy
          </span>
        </button>
        <button
          type="button"
          className={`buttonField ${ratingScore === 3 ? 'activeButton' : ''}`}
          onClick={() => setRatingScore(3, id)}
          onMouseEnter={() => setHoverRating(3)}
          onMouseLeave={() => setHoverRating(0)}
        >
          {NuetralFace()}
          <span>
            Neutral
          </span>
        </button>
        <button
          type="button"
          className={`buttonField ${ratingScore === 1 ? 'activeButton' : ''}`}
          onClick={() => setRatingScore(1, id)}
          onMouseEnter={() => setHoverRating(1)}
          onMouseLeave={() => setHoverRating(0)}
        >
          {DisappointedFace()}
          <span>
            Sad
          </span>
        </button>
      </div>
      <div className="description" id={id}>
        {desc}
      </div>
    </div>
  );
};

export default EmotionRating;
